import React, { useState } from "react";
import "./AboutUs.css";
import { getCustomerData } from "../../redux-toolkit/customer/customerSlice";
import { useSelector } from "react-redux";
import BookingModal from "../BookingModal/BookingModal";

const AboutUs = ({ query, oss, om }) => {
  const customerData = useSelector(getCustomerData);
  const [readMore, setReadMore] = useState(false);

  return (
    <div className="aboutUs-container">
      <div className="aboutUs-info">
        <h2 className="aboutUs-title">{query}</h2>
        <p className="aboutUs-intro">{om}</p>

        <div>
          <BookingModal />
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
